
import { Vue, Component, Prop } from "vue-property-decorator";

@Component
export default class PageHeader extends Vue {
  @Prop({ type: String, default: "" }) readonly title!: string;
  @Prop({ type: String, default: "" }) readonly body!: string;
}
